// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cd8744c5","239":"30d62288","455":"fbf3df40"}[chunkId] + ".chunk.js";
};